import React, { isValidElement } from "react";
import Message from "assets/scripts/components/common/Message/Message";
import { FormattedMessage } from "react-intl";
function shouldWrap(children) {
    if (typeof children === "string") {
        return true;
    }
    if (isValidElement(children)
        && children.type === FormattedMessage
        && (children.props.tagName == null || children.props.tagName === "span")) {
        return true;
    }
    return false;
}
const Section = ({ title, children }) => (<div className="vr vr_x3">
		<div className="vr vr_x1">
			<h3 className="hdg hdg_subtle">
				<Message value={title}/>
			</h3>
		</div>
		<div className="text">
			{shouldWrap(children) ? (<p>{children}</p>) : children}
		</div>
	</div>);
export default Section;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/legal/Section/Section.tsx